/**
 * URL Helper Utilities
 * 
 * Provides environment-aware URL generation for the application.
 * Works in both development (localhost) and production (shiyou.vercel.app) environments.
 */

/**
 * Get page URL with environment awareness
 * Works in both development (localhost) and production (shiyou.vercel.app)
 * 
 * Priority order for base URL:
 * 1. REACT_APP_BASE_URL (environment variable, if set)
 * 2. window.location.origin (runtime detection from current page)
 * 3. 'https://shiyou.vercel.app' (fallback for production)
 * 
 * @param route - Page route (e.g., '/preview', '/signup', 'preview')
 * @returns Full URL for the route with proper base URL and normalized route
 * 
 * @example
 * // In development
 * getPageUrl('/preview') // Returns: 'http://localhost:3000/preview'
 * 
 * // In production
 * getPageUrl('/preview') // Returns: 'https://shiyou.vercel.app/preview'
 * 
 * // Route normalization (with or without leading slash)
 * getPageUrl('preview')  // Returns: 'http://localhost:3000/preview' (normalized)
 * getPageUrl('/preview') // Returns: 'http://localhost:3000/preview'
 */
export const getPageUrl = (route: string): string => {
  // Priority: Environment variable > window.location > fallback
  const baseUrl = process.env.REACT_APP_BASE_URL || 
                  (typeof window !== 'undefined' ? window.location.origin : '') ||
                  'https://shiyou.vercel.app';
  
  // Ensure route starts with /
  const normalizedRoute = route.startsWith('/') ? route : `/${route}`;
  
  return `${baseUrl}${normalizedRoute}`;
};

